import type { ContentLanguage } from '@/utils/contentLanguage';

import { WrittenInLanguageLabel } from '@/components/WrittenInLanguageLabel/WrittenInLanguageLabel';

interface AgendaLanguageLabelProps {
    /** The one language the agenda is written in. */
    agendaLanguage: ContentLanguage;
    /** The reader's language: the label shows only when the agenda is written in the other one. */
    readerLanguage: ContentLanguage;
}

const AGENDA_LABELS = {
    en: 'meetingAgenda.writtenInLanguage.en',
    fr: 'meetingAgenda.writtenInLanguage.fr',
} as const;

/**
 * Says which language the agenda is written in, for a reader whose own language is the other one: an
 * agenda keeps the language it was created or generated in, and is never translated for its reader.
 */
export const AgendaLanguageLabel = ({
    agendaLanguage,
    readerLanguage,
}: AgendaLanguageLabelProps) => (
    <WrittenInLanguageLabel
        contentLanguage={agendaLanguage}
        readerLanguage={readerLanguage}
        labels={AGENDA_LABELS}
        dataTestId={'agenda-language-label'}
    />
);
